import { fetchCsrf } from "./fetch_csrf"

export async function  trackAnalytics(trackUrl, body = undefined) {
  const csrfToken = await fetchCsrf()
  const url = new URL(trackUrl)
  const options = {
    method: "post",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken
    }
  }

  if (body) {
    options.body = JSON.stringify(body)
    // For search queries we use a frontend uid to limit spam and
    // block invalid requests that don't pass the param as a **query**
    // parameter.
    if (body.uid) {
      url.searchParams.set("uid", body.uid)
    }
  }
  fetch(url, options)
}
